import React, { useState, useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';

// When this component mounts, it animates the transition
// between an initial height (startHeight) and mounted child height
export const Expandable = ({
    canAnimate = true,
    className,
    children,
    startHeight,
}) => {
    const [height, setHeight] = useState(canAnimate ? startHeight : 'auto');
    const [opacity, setOpacity] = useState(canAnimate ? 0 : 1);

    const measureRef = useRef(null);

    useEffect(() => {
        if (canAnimate) {
            const newHeight = `${measureRef.current.scrollHeight}px`;
            // Immediately trigger update to animate
            setHeight(newHeight);
            // Fade in
            setOpacity(1);
            const autoHeightTimeout = setTimeout(() => {
                // Set back to auto height to account for child
                // updates (timesgrid lazyload, window resizes, etc.)
                setHeight('auto');
            }, 500);
            return () => clearTimeout(autoHeightTimeout);
        }
    }, [canAnimate]);

    return (
        <ExpandableSection className={className} height={height}>
            <FadeIn ref={measureRef} opacity={opacity}>
                {children}
            </FadeIn>
        </ExpandableSection>
    );
};

// Hide flow during animation, but show overflow after height auto,
// to allow tooltip popup
const ExpandableSection = styled.div`
    margin-bottom: 32px;
    transition: height 0.3s ease;
    ${(p) =>
        p.height !== 'auto'
            ? css`
                  height: ${p.height};
                  overflow: hidden;
              `
            : 'height: auto;'}
`;

const FadeIn = styled.div`
    opacity: ${(p) => p.opacity};
    ${(p) =>
        p.opacity === 1 &&
        css`
            transition: opacity 0.3s ease;
        `};
`;

export default Expandable;
